import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export function useNavigateAfterTerminate() {
  const navigate = useNavigate()
  return useCallback(() => {
    fetch('/api/logout')
    navigate('/web/afterTerminate', { state: { fromApp: true } })
  }, [navigate])
}
